var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 49,
    viewBox: "0 0 38 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons",
    clipPath: "url(#clip0_27832_33649)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31 6.5H35C36.1 6.5 37 7.4 37 8.5V47.5H3C1.9 47.5 1 46.6 1 45.5V8.5C1 7.4 1.9 6.5 3 6.5H7",
    stroke: "#0C9BED",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M31 10.5H33V43.5H5V10.5H7",
    stroke: "#0C9BED",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M26 5.5H23C23 3.29 21.21 1.5 19 1.5C16.79 1.5 15 3.29 15 5.5H12C10.34 5.5 9 6.84 9 8.5V11.5H29V8.5C29 6.84 27.66 5.5 26 5.5Z",
    stroke: "#0C9BED",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M19 4.5V6.5",
    stroke: "#0C9BED",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M19 37.5C24.5228 37.5 29 33.0228 29 27.5C29 21.9772 24.5228 17.5 19 17.5C13.4772 17.5 9 21.9772 9 27.5C9 33.0228 13.4772 37.5 19 37.5Z",
    stroke: "#0C9BED",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M21 25.5V22.5H17V25.5H14V29.5H17V32.5H21V29.5H24V25.5H21Z",
    stroke: "#0C9BED",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27832_33649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 48,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotebook);
export default __webpack_public_path__ + "static/media/notebook.cd6379cb7a94ff6dfce0977215205cd1.svg";
export { ForwardRef as ReactComponent };